import {
  type PaymentFormData,
  type PaymentPack,
  PaymentStatus,
  type ProcessPaymentHandler,
  type PurchasePrice,
} from "../types";
import { useFormik } from "formik";
import { getPaymentFormValidationSchema } from "../utils/creditCardValidation";
import { useMemo } from "react";

const INITIAL_VALUES: PaymentFormData = {
  packs: [],
  creditCardInfo: {
    nameOnCard: "",
    cardNumber: "",
    expirationMonth: "",
    expirationYear: "",
    securityCode: "",
    cardProviderType: "",
  },
  billingInfo: {
    country: "United States",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
  },
};

type Props = {
  processPayment: ProcessPaymentHandler;
  purchasePrice: PurchasePrice;
  paymentStatus: PaymentStatus;
  packs: PaymentPack[];
};

export const usePaymentForm = ({ packs, purchasePrice, paymentStatus, processPayment }: Props) => {
  const initialValues = useMemo(() => {
    return { ...INITIAL_VALUES, packs };
  }, [packs]);

  const submit = async (formData: PaymentFormData) => {
    if (paymentStatus === PaymentStatus.Loading) {
      return;
    }

    processPayment({ formData, purchasePrice });
  };

  const formik = useFormik<PaymentFormData>({
    initialValues,
    initialErrors: { packs: [{ licensesCount: "" }] },
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: useMemo(() => getPaymentFormValidationSchema(packs), [packs]),
    onSubmit: submit,
    enableReinitialize: true,
  });

  const { isValid, submitForm } = formik;

  return { isValid, submitForm, formik };
};
